module.exports = __webpack_public_path__ + "img/trustpilot-logo.a2bab44f.png";